import React, { Component } from 'react';

class UnauthorisedAccessPage extends Component {
  state = {};

  render() {
    return <div>Unauthorised Access Page</div>;
  }
}

export default UnauthorisedAccessPage;
